import { useLazyQuery } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import Moment from 'moment';
import { useCallback, useEffect } from 'react';

import { SEND_TOKEN } from 'queries';
import { delayButtonState } from 'states/app';
import { notificationState } from 'states/notification';
import { graphQLError } from 'utils/Helpers';

const useSendToken = (accessReportId, idButton) => {
  const setNotification = useSetAtom(notificationState);
  const setDelayButton = useSetAtom(delayButtonState(idButton));

  const [query, { loading, data, error }] = useLazyQuery(SEND_TOKEN, {
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!loading && data?.result === false) {
      setNotification({
        class: 'notification--alert',
        text: 'UnknownError',
      });
    }
  }, [loading, data, setNotification]);

  useEffect(() => {
    error &&
      setNotification({
        class: 'notification--alert',
        text: graphQLError(error),
      });
  }, [error, setNotification]);

  const sendToken = useCallback(
    (token, resend) =>
      query({
        variables: {
          accessReportId,
          token,
        },
      }).then((result) => {
        if (!result?.errors && resend) {
          setDelayButton({ moment: Moment().format() });
          setNotification({
            text: 'ResendTokenSent',
          });
        }
      }),
    [accessReportId, query, setDelayButton, setNotification]
  );

  return { loading, sendToken };
};

export default useSendToken;
